import React, { useState } from 'react';


export const DateSelectionFavoriteOddsWh = (props) => {
    const [active, setActive] = useState('')

    function handleOnChange(el) {
        switch (el) {
            case '1H': props.onChange(0);
                break;
            case '3H': props.onChange(1);
                break;
            case 'Oggi': props.onChange(2);
                break;
            case '48H': props.onChange(3);
                break;
            case '72H': props.onChange(4);
                break;
            default: props.onChange(5);
        }
        setActive(el);
    }

    return (
        <div className="dateSelection__favorite--wh ">
            <div className="dateSelection__items">
                {props.elems.map((el, i) =>
                    <button className={el == active ? `selected dateSelection-${el}` : `notSelected dateSelection-${el}`} onClick={() => handleOnChange(el)} key={i}>{el}</button>
                )}
            </div>
        </div>
    );
}